import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  static values = {
    continueText: { type: String, default: "Continue default" },
  }

  connect() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.innerHTML = this.continueTextValue

      const hasBulkData = this.checkForBulkData()
      this.submitButtonTarget.disabled = !hasBulkData

      // Handle tooltip based on initial state
      const tooltipController = this.application.getControllerForElementAndIdentifier(
        this.submitButtonTarget,
        "tooltip",
      )

      if (tooltipController) {
        if (hasBulkData) {
          tooltipController.disable()
        } else {
          tooltipController.enable()
        }
      }
    }

    // Store the bound function reference
    this.boundHandleFileStatusChange = this.handleFileStatusChange.bind(this)

    // Listen for file upload status events from any file upload component
    document.addEventListener("file-upload:status-changed", this.boundHandleFileStatusChange)
  }

  disconnect() {
    document.removeEventListener("file-upload:status-changed", this.boundHandleFileStatusChange)
  }

  // Check if bulk search or bulk finder data is present
  checkForBulkData() {
    const form = this.element

    // Check for bulk search hidden input
    const bulkSearchInput = form.querySelector('input[name="leads_import[bulk_search_id]"]')
    if (bulkSearchInput && bulkSearchInput.value) {
      return true
    }

    // Check for bulk finder hidden input
    const bulkFinderInput = form.querySelector('input[name="leads_import[bulk_finder_id]"]')
    if (bulkFinderInput && bulkFinderInput.value) {
      return true
    }

    return false
  }

  handleFileStatusChange(event) {
    if (!this.hasSubmitButtonTarget) return

    const { isFileSelected } = event.detail

    this.submitButtonTarget.disabled = !isFileSelected

    // Toggle the tooltip - enable it when button is disabled, disable it when button is enabled
    const tooltipController = this.application.getControllerForElementAndIdentifier(this.submitButtonTarget, "tooltip")

    if (tooltipController) {
      if (isFileSelected) {
        tooltipController.disable()
      } else {
        tooltipController.enable()
      }
    }
  }
}
